import { Team } from "~/api/Api";
import { routes } from "~/router";

export type OnboardingStep = "platform" | "survey";

/**
 * The onboarding step the team still has to complete, in order, or null.
 * The backend raises the flags only for the current team and only for users
 * who can complete the step. A blocked subscription goes to billing first.
 */
export const getRequiredOnboardingStep = (
  team: Team | null,
): OnboardingStep | null => {
  if (!team?.subscription?.healthy) return null;
  if (team.platform_setup_required) return "platform";
  if (team.onboarding_survey_required) return "survey";

  return null;
};

export const onboardingStepPath = (step: OnboardingStep) =>
  step === "platform"
    ? routes.onboarding.platform()
    : routes.onboarding.survey();
